import '@npm-questionpro/wick-ui-editor/dist/style.css'
import '@npm-questionpro/wick-ui-icon/dist/wu-icon.css'
import {WuTranslateProvider} from '@npm-questionpro/wick-ui-lib'
import '@npm-questionpro/wick-ui-lib/dist/style.css'
import ReactDOM from 'react-dom/client'

import {BrowserRouter} from 'react-router'
import {App} from './App'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

const root = ReactDOM.createRoot(rootElement as HTMLElement)

const renderApp = (): void => {
  root.render(
    <WuTranslateProvider defaultLocale="en">
      <BrowserRouter useTransitions={false}>
        <App />
      </BrowserRouter>
    </WuTranslateProvider>,
  )
}

// import.meta.env.DEV is hardcoded false by Vite for any `vite build` output —
// this branch, and the msw/browser import chain behind it, cannot exist in a
// production bundle. Structural, not just a convention to remember.
if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === 'true') {
  void import('./mocks/enableMocking').then(({enableMocking}) =>
    enableMocking().then(renderApp),
  )
} else {
  renderApp()
}
